module.exports = __webpack_public_path__ + "static/media/overviewpage.c57fc22f.jpg";